// export default CategoriesSections;
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import CardSVG from "../../assets/cart-plus-svgrepo-com.svg";
import { Autoplay, Navigation } from "swiper/modules";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { message, Modal, Button } from "antd";
import Loader2 from "../../Components/Loader2";
import ServerError from "../../utils/ServerError";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { useGetCategoriesQuery } from "../../RTK/Slices/Slices/apiSliceMeat";
import { DEFAULT_IMAGE_URL } from "../../config/apiConfig";
import {
  addToFavorites,
  addToCart,
  isFavorite as checkIsFavorite,
  calculateDiscountedPrice,
} from "../../utils/localStorage";

function CategoriesSections() {
  const navigate = useNavigate();
  const token = localStorage.getItem("user");

  // State للتحديث المحلي
  const [favoriteProducts, setFavoriteProducts] = useState(new Set());
  const [, setCartCount] = useState(0);

  // Modal state
  const [isModalOpen, setIsModalOpen] = useState(false);

  // كمية كل منتج على حدة (مفتاح: product_id) عشان كل كارت يكون له عداد مستقل
  const [quantities, setQuantities] = useState({});
  const getQty = (productId) => quantities[productId] || 1;
  const changeQty = (product, delta, e) => {
    e.stopPropagation();
    const maxQty = Math.min(parseFloat(product.stock) || 99, 99);
    setQuantities((prev) => {
      const current = prev[product.product_id] || 1;
      const next = Math.min(maxQty, Math.max(1, current + delta));
      return { ...prev, [product.product_id]: next };
    });
  };

  // API calls
  const {
    data: categoriesData,
    isLoading: isCategoriesLoading,
    isError: isCategoriesError,
  } = useGetCategoriesQuery();

  // تحديث حالة المفضلة عند تحميل المكون
  useEffect(() => {
    const updateFavoriteState = () => {
      const allCategories = categoriesData?.data ?? [];
      const favoriteSet = new Set();

      allCategories.forEach((category) => {
        category.products?.forEach((product) => {
          if (checkIsFavorite(product.product_id)) {
            favoriteSet.add(product.product_id);
          }
        });
      });

      setFavoriteProducts(favoriteSet);
    };

    if (categoriesData) {
      updateFavoriteState();
    }
  }, [categoriesData]);

  // Data processing
  const allCategories = categoriesData?.data ?? [];
  console.log("All Categories Data:", allCategories);

  // Filter categories that have products with stock > 0
  const filteredCategories = allCategories.filter((category) => {
    if (!category.products || category.products.length === 0) {
      return false;
    }

    const hasAvailableProducts = category.products.some(
      (product) => parseFloat(product.stock) > 0
    );

    return hasAvailableProducts;
  });

  // Filter products within each category to only show those with stock > 0
  const categoriesWithFilteredProducts = filteredCategories.map((category) => ({
    ...category,
    products: category.products.filter(
      (product) => parseFloat(product.stock) > 0
    ),
  }));

  // Event handlers
  const handleAddToCart = async (product, productQuantity, event) => {
    event.stopPropagation();

    if (!token) {
      setIsModalOpen(true);
      return;
    }

    try {
      const success = addToCart(product, productQuantity);
      if (success) {
        message.success("تمت إضافة المنتج إلى السلة بنجاح!");
        // تحديث عدد العناصر في السلة
        setCartCount((prev) => prev + productQuantity);
      } else {
        message.error("فشل إضافة المنتج إلى السلة.");
      }
    } catch (error) {
      message.error("فشل إضافة المنتج إلى السلة. يرجى المحاولة مرة أخرى.");
      console.error("فشل إضافة المنتج إلى السلة:", error);
    }
  };

  const handleAddToFavourite = async (product, event) => {
    event.stopPropagation();

    if (!token) {
      setIsModalOpen(true);
      return;
    }

    try {
      const wasAdded = addToFavorites(product);

      // تحديث الحالة المحلية
      setFavoriteProducts((prev) => {
        const newSet = new Set(prev);
        if (wasAdded) {
          newSet.add(product.product_id);
          message.success("تمت إضافة المنتج إلى المفضلة بنجاح!");
        } else {
          newSet.delete(product.product_id);
          message.success("تمت إزالة المنتج من المفضلة بنجاح!");
        }
        return newSet;
      });
    } catch (error) {
      message.error("فشل تحديث المفضلة. يرجى المحاولة مرة أخرى.");
      console.error("فشل تحديث المفضلة:", error);
    }
  };

  const closeModal = () => setIsModalOpen(false);

  const navigateToLogin = () => {
    setIsModalOpen(false);
    navigate("/Login");
  };

  // Helper functions
  const isFavorite = (productId) => {
    return favoriteProducts.has(productId);
  };

  const getProductImage = (product) => {
    if (
      product.variations &&
      product.variations.length > 0 &&
      product.variations[0].media &&
      product.variations[0].media.length > 0
    ) {
      return product.variations[0].media[0].display_url;
    }
    return product.image_url || DEFAULT_IMAGE_URL;
  };

  // Loading and error states
  if (isCategoriesLoading) {
    return <Loader2 />;
  }

  if (isCategoriesError) {
    return <ServerError />;
  }

  if (categoriesWithFilteredProducts.length === 0) {
    return (
      <div className="container mx-auto py-10 text-center">
        <p className="text-lg text-gray-600">لا توجد منتجات متاحة حالياً</p>
      </div>
    );
  }

  return (
    <>
      {categoriesWithFilteredProducts.map((category) => (
        <div key={category.id} className="bg-gray-100">
          {/* Category Header Image */}
          <div className="flex items-center justify-center w-full !pt-5 md:!pt-10 container">
            <img
              className="w-full"
              src={category.image_url || DEFAULT_IMAGE_URL}
              alt={category.name}
              loading="lazy"
              onError={(e) => {
                e.target.src = DEFAULT_IMAGE_URL;
              }}
            />
          </div>

          {/* Products Swiper */}
          <div className="container">
            <Swiper
              rewind={true}
              navigation={true}
              spaceBetween={10}
              slidesPerView={3}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              modules={[Autoplay, Navigation]}
              className="mySwiper !py-5 md:!py-10"
              breakpoints={{
                1320: {
                  slidesPerView: 5,
                  spaceBetween: 10,
                },
                1140: {
                  slidesPerView: 4,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
                640: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                0: {
                  slidesPerView: 1.5,
                  spaceBetween: 10,
                },
              }}
            >
              {category.products.map((product) => (
                <SwiperSlide key={product.product_id} className="rounded-2xl">
                  <div
                    className="rounded-2xl p-5 cursor-pointer hover:-translate-y-2 transition-all relative"
                    style={{
                      backgroundColor: "var(--category-card-bg-color, #ffffff)",
                      border: "var(--category-card-border, 1px solid #e0e0e0)",
                    }}
                  >
                    {/* Favorite Button */}
                    <div className="bg-gray-100 w-10 h-10 flex items-center justify-center rounded-full cursor-pointer absolute top-4 right-4">
                      <FontAwesomeIcon
                        className={`${
                          isFavorite(product.product_id)
                            ? "text-mainColor"
                            : "text-slate-500 hover:text-HovMainColor"
                        } transition-colors`}
                        onClick={(e) => handleAddToFavourite(product, e)}
                        icon={faHeart}
                      />
                    </div>

                    {/* Product Link */}
                    <Link to={`Products/${product.product_id}`}>
                      {/* Product Image */}
                      <div className="w-5/6 h-[210px] flex justify-center items-center overflow-hidden mx-auto aspect-w-16 aspect-h-8 md:mb-2 mb-4">
                        <img
                          src={getProductImage(product)}
                          alt={product.name}
                          className="!h-auto !w-full object-contain"
                          loading="lazy"
                          onError={(e) => {
                            e.target.src =
                              DEFAULT_IMAGE_URL;
                          }}
                        />
                      </div>

                      {/* Product Info */}
                      <div>
                        <h3 className="text-sm text-center font-extrabold text-gray-800 line-clamp-2">
                          {product.name}
                        </h3>

                        {/* Price Section */}
                        <div className="flex items-center justify-center gap-5 my-2">
                          {parseFloat(product.default_sales_discount) > 0 && (
                            <h4 className="text-lg text-gray-500 font-bold line-through">
                              EGP {parseFloat(product.price).toFixed(0)}
                            </h4>
                          )}
                          <h4 className="text-lg text-mainColor font-bold">
                            EGP{" "}
                            {parseFloat(
                              calculateDiscountedPrice(
                                product.price,
                                product.default_sales_discount
                              )
                            ).toFixed(0)}
                          </h4>
                        </div>


                      </div>
                    </Link>

                    {/* +/- quantity controls - نفس شكل الاستيبر في كارت المنتج */}
                    <div
                      className="flex items-center justify-center gap-3 mb-3"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <button
                        onClick={(e) => changeQty(product, -1, e)}
                        className="w-8 h-8 flex items-center justify-center rounded-full border-2 border-mainColor text-mainColor font-bold text-lg leading-none hover:bg-mainColor hover:text-white transition-colors select-none"
                        disabled={getQty(product.product_id) <= 1}
                        style={{ opacity: getQty(product.product_id) <= 1 ? 0.4 : 1 }}
                      >
                        −
                      </button>
                      <span className="w-8 text-center font-bold text-gray-800 text-base select-none">
                        {getQty(product.product_id)}
                      </span>
                      <button
                        onClick={(e) => changeQty(product, 1, e)}
                        className="w-8 h-8 flex items-center justify-center rounded-full border-2 border-mainColor text-mainColor font-bold text-lg leading-none hover:bg-mainColor hover:text-white transition-colors select-none"
                        disabled={getQty(product.product_id) >= Math.min(parseFloat(product.stock) || 99, 99)}
                        style={{ opacity: getQty(product.product_id) >= Math.min(parseFloat(product.stock) || 99, 99) ? 0.4 : 1 }}
                      >
                        +
                      </button>
                    </div>

                    {/* Add to Cart Button */}
                    <div className="flex justify-center items-center mt-3">
                      <button
                        onClick={(e) => handleAddToCart(product, getQty(product.product_id), e)}
                        className="relative flex items-center justify-center w-[140px] h-[40px] bg-mainColor hover:bg-HovMainColor rounded-lg border-none shadow-md cursor-pointer overflow-hidden transition duration-500 active:scale-95 group"
                      >
                        <span className="absolute left-[-50px] flex items-center justify-center w-[30px] h-[30px] rounded-full bg-transparent overflow-hidden z-10 transition duration-500 group-hover:translate-x-[58px] group-hover:rounded-full">
                          <img src={CardSVG} alt="CardSVG" />
                        </span>
                        <p className="flex items-center justify-center h-full text-sm font-semibold text-neutral-800 z-10 transition duration-500 group-hover:translate-x-[10px]">
                          Add to Cart
                        </p>
                      </button>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      ))}

      {/* Login Modal */}
      <Modal
        title="تنبيه"
        open={isModalOpen}
        onCancel={closeModal}
        footer={[
          <Button key="cancel" onClick={closeModal}>
            إغلاق
          </Button>,
          <Button key="Login" type="primary" onClick={navigateToLogin}>
            التسجيل الآن
          </Button>,
        ]}
      >
        <p>عذرًا، يجب تسجيل الدخول لإضافة المنتجات إلى السلة أو المفضلة.</p>
      </Modal>
    </>
  );
}

export default CategoriesSections;
